import { Component, inject, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { HeaderComponent } from '../../components/header/header.component';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Psychologist } from '../../models/psychologists';
import { PsychologistService } from '../../services/psychologist.service';
import { Invite } from '../../models/invite';
import { InviteService } from '../../services/invite.service';
import { environment } from '../../../environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatePipe } from '@angular/common';
import { PhoneNumberPipe } from '../../pipes/phone-number.pipe';
import { AUTH_SERVICE, AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-invites',
  imports: [
    HeaderComponent,
    MatIcon,
    TranslatePipe,
    DatePipe,
    PhoneNumberPipe
  ],
  templateUrl: './invites.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './invites.component.scss',
})
export class InvitesComponent {
  authService: AuthService = inject(AUTH_SERVICE);
  psychologistService: PsychologistService<Psychologist> = inject(PsychologistService<Psychologist>);
  translate: TranslateService = inject(TranslateService);
  inviteService: InviteService<Invite> = inject(InviteService<Invite>);
  
  snackBar: MatSnackBar = inject(MatSnackBar);
  invites: WritableSignal<Invite[]> = signal<Invite[]>([]);

  constructor(){
    this.loadData();
  }

  async loadData(){
    let psychologistId = this.psychologistService.psychologist()?.id;
    if(!psychologistId){
      if(!this.authService.user()){
        await this.authService.getUser();
      }
      const userId = this.authService.user()?.id;
      if(userId){
        await this.psychologistService.getPsychologistByUserId(userId);
        psychologistId = this.psychologistService.psychologist()?.id;
      }
    }    
    
    if(psychologistId){
      this.inviteService.getPendingByPsychologistId(psychologistId).then(
        (data) => {
          this.invites.set(data);
        }
      )
    }
  }

  back(){
    history.back();
  }

  copyToClipboard(token: string){    
    if ('vibrate' in navigator) {
      navigator.vibrate(100);
    }

    if('clipboard' in navigator){
      navigator.clipboard.writeText(`${environment.HOST}/invite/${token}`);

      const  message = this.translate.instant('info.invite_created');
      const action:string = this.translate.instant('buttons.dismiss');
      this.snackBar.open(message, action);

    }
  }

}
